export const home_i18n = {
    text1: "Senden Sie Ihren ersten Check-in zur Unterschrift",
    text2: "Der virtuelle Check-in erfasst die biometrischen Daten des Gastes und verknüpft sie mit seiner Buchung.",
    text3: "Check-in senden",
    text4: 'Start',
    text5: "Check-in",
    text6: "Willkommen",
    text7: "Check-in-Konfiguration",
    text8: "Mein Konto",
    text9: "Check-in-Konfiguration",
    text10: "Abmelden",
    text11: "Hotelbild",
    text12: "Hotelrichtlinien",
    text13: "Willkommensnachrichten",
    text14: "Laden Sie Ihr Hotellogo hoch",
    text15: "Logo auswählen oder hierher ziehen",
    text16: "Abbrechen",
    text17: "Name des Hotels",
    text18: "Änderungen speichern",
    text19: "Logo ändern",
    text20: "Herunterladen",
    text21: "Unterschriftenverlauf",
    text22: "Übersicht der von den Gästen unterschriebenen Dokumente.",
    text23: "Filter:",
    text24: "Deaktiviert",
    text25: "Nach Datum",
    text26: "Nach Land",
    text27: "Name",
    text28: "Nachname",
    text29: "Nationalität",
    text30: "Check-in-Datum",
    text31: "Synchronisiert",
    text32: "Optionen",
    text33: "Keine Daten",
    text34: "Zeilen pro Seite:",
    text35: "Suchen",
    text36: "Länder",
    text37: "Von",
    text38: "Bis",
    text39: "COPYRIGHT © 2022 , Alle Rechte vorbehalten WACheckines",
    text40: "Erstellt mit",
    text41: "Exportieren",
    text42: "Details ansehen",
    text43: "Unterschriebenes PDF ansehen",
    text44: "Löschen",
    text45: "Option auswählen",
    //aca
    text46: "Zahlungsmethode hinzufügen",
    text47: "Registrieren oder aktualisieren Sie die Zahlungsmethode, über die die monatlichen Abbuchungen erfolgen.",
    text48: "Gesamtschuld",
    text49: "Zahlung erfolgreich",

    p1: "Sie nutzen die Testversion",
    p2: "Sie haben noch",
    p3: "Tage übrig!",
    p4: "Der Testzeitraum ist abgelaufen.",
    p5: "Jetzt abonnieren",
    p6: "Ihre kostenlose Testphase ist beendet!",

};